document.querySelectorAll('.swiper').forEach(swiperEl => {
    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children);

    for (let i = slides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [slides[i], slides[j]] = [slides[j], slides[i]];
    }

    slides.forEach(slide => wrapper.appendChild(slide));

    new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
            0: { slidesPerView: 1.3 },
            600: { slidesPerView: 2 },
            900: { slidesPerView: 3 },
            1200: { slidesPerView: 4 }
        }
    });
});

new Swiper('.swiper-single-page', {
  slidesPerView: 2.5,
  spaceBetween: 12,
  breakpoints: {
            0: { slidesPerView: 1.5 },
            600: { slidesPerView: 2 },
            900: { slidesPerView: 3 },
        }
});




document.querySelectorAll('.add_to_cart_btn').forEach(button => {

    button.addEventListener('click', async () => {

        const crossSale = button.dataset.crosssale;
        const variantId = button.dataset.variant;
        const pImage   = button.dataset.image;
        const pName    = button.dataset.name;
        const pPrice   = button.dataset.price;
        const pqty = Number(button.dataset.qty ?? 1);

        button.innerText = "Se adaugă...";

        await fetch('/cart/add.js', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: pqty })
        });

        const cart = await fetch('/cart.js').then(r => r.json());

    
        button.innerText = "Adăugat ✔";

        popupOpen(
            crossSale,
            pImage,
            pName,
            formatRON(pPrice),
            cart.item_count,
            formatRON(cart.total_price / 100)
        );

        setTimeout(() => {
            button.innerText = "Adaugă în Coș";
        }, 2000);
    });
});

//function formatRON(value) {

 //   value = Number(value).toFixed(2);

//    value = value.replace(".", ",");

  //  value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    //return value;
//}

//function formatRON(value) {
  // 1. Transformăm în număr cu 2 zecimale (ex: "28349.00")
  //let val = Number(value).toFixed(2);
  
  // 2. Punem virgula pentru zecimale (ex: "28349,00")
//  val = val.replace(".", ",");
  
  // 3. Punem punctul pentru mii (ex: "28.349,00")
  //val = val.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  
  // 4. Tăiem prețul în două de la virgulă
  //let parts = val.split(',');
  
  // 5. Returnăm formatul cu zecimale mici
  //return `<span>${parts[0]}</span><sup style="font-size: 0.6em; top: -0.5em; position: relative; margin-left: 1px;">${parts[1]}</sup>`;
//}
function formatRON(value) {
  let val = Number(value).toFixed(2);
  val = val.replace(".", ",");
  val = val.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  
  let parts = val.split(',');
  // Am schimbat top la -0.1em ca să nu mai fie așa sus
  return `<span>${parts[0]}</span><sup style="font-size: 0.6em; top: -0.1em; position: relative; margin-left: 2px;">${parts[1]}</sup>`;
}

new Swiper(".offerSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".offerSwiper-next",
        prevEl: ".offerSwiper-prev",
    }
});

function updateCountdown() {
    document.querySelectorAll(".countdown_box").forEach(box => {
        let end = new Date(box.dataset.endTime).getTime();
        let now = new Date().getTime();
        let diff = end - now;

        if (diff < 0) { box.querySelector(".countdown_timer").innerHTML = "Expirat"; return; }

        let h = Math.floor(diff / (1000*60*60));
        let m = Math.floor((diff % (1000*60*60)) / (1000*60));
        let s = Math.floor((diff % (1000*60)) / 1000);

        box.querySelector(".countdown_timer").innerHTML = 
            `<span>${h}<small>H</small></span> : <span>${m}<small>M</small></span> : <span>${s}<small>S</small></span>`;
    });
}
setInterval(updateCountdown, 1000);

document.querySelectorAll('.add_cart_btn').forEach(button => {

    button.addEventListener('click', async () => {

        const crossSale = button.dataset.crosssale;
        const variantId = button.dataset.variant;
        const pImage   = button.dataset.image;
        const pName    = button.dataset.name;
        const pPrice   = button.dataset.price;

        button.innerText = "Se adaugă...";

        await fetch('/cart/add.js', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        const cart = await fetch('/cart.js').then(r => r.json());



        button.innerText = "Adăugat ✔";

        popupOpen(
            crossSale,
            pImage,
            pName,
            formatRON(pPrice),
            cart.item_count,
            formatRON(cart.total_price / 100)
        );

        setTimeout(() => {
            button.innerText = "Adaugă în Coș";
        }, 2000);
    });
});

function openVideoPopup(url) {
    document.getElementById("videoPopup").style.display = "flex";
    document.getElementById("videoFrame").src = url;
}

function closeVideoPopup() {
    document.getElementById("videoPopup").style.display = "none";
    document.getElementById("videoFrame").src = "";
} 


new Swiper(".cross-sale-swiper-single", {
    slidesPerView: 4,
    spaceBetween: 14,
    breakpoints: {
        320: { slidesPerView: 2 },
        640: { slidesPerView: 4 },
    }
}); 